import { Injectable } from '@angular/core';
import { isStringEmpty } from '@common/helpers';
import { SupportClass } from '@lib/components/support-class';
import { StaticMsgPipe } from '@lib/pipes/static-msg/static-msg.pipe';
import { CommonLibService } from '@lib/services';
import { AppConstants } from '@conf/app.constants';

@Injectable()
export class TripSummaryService extends SupportClass {
  // 定数用
  public appConstants = AppConstants;

  constructor(private _staticMsg: StaticMsgPipe, _common: CommonLibService) {
    super();
  }

  // (1.1.25) & (1.1.26) & (1.1.53)
  getTerminalAndGate(
    isNhGroupOperated: boolean = false,
    locationCode: string = '',
    terminal: string = '',
    gate?: string
  ) {
    let terminalName = this.getTerminal(terminal, locationCode, isNhGroupOperated);
    let gateName = this.getGate(gate);
    const slash = this._staticMsg.transform('label.slash');
    return [terminalName, gateName].filter(Boolean).join(slash);
  }

  // (1.1.25) 出発ターミナル & (1.1.53) 到着ターミナル
  getTerminal(terminal: string, locationCode: string, isNhGroupOperated: boolean): string {
    /** 1)
     * 当該セグメント情報.(departure || arrival).terminalが存在する場合、
     * 当該セグメント情報.(departure || arrival).terminalを表示する。
     */
    if (terminal) return this._staticMsg.transform('label.terminal.departure', { '0': terminal });
    /** 2)
     * 当該セグメント情報.(departure || arrival).terminalが存在しない場合、
     * 2.1) 当該セグメント情報.(departure || arrival).locationCode="HND"(haneda)、
     *      かつ当該セグメント情報.isNhGroupOperated=true (NHグループ運航)の場合に限り、
     *      未確定である旨を表示する。
     * 2.2) 上記以外の場合、非表示とする。
     */
    return locationCode === 'HND' && isNhGroupOperated
      ? this._staticMsg.transform('label.terminal.departure', {
          '0': this._staticMsg.transform('label.terminalName.notReturn'),
        })
      : '';
  }

  // (1.1.26) 出発搭乗口
  getGate(gate: string = ''): string {
    /** 1)
     * 当該セグメント情報.departure.gateが存在する場合、
     * "label.gate2"を表示する。
     * {0} : 当該セグメント情報.departure.gate
     */
    if (gate) return this._staticMsg.transform('label.gate2', { '0': gate });
    else return gate;
  }

  // (1.1.19) フライト時間ライン - (3)
  isOtherClass(operatingAirlineCode?: string): string {
    // 3) 当該セグメント情報.isNhGroupOperated=false (NHグループ運航以外)の場合、グレーを表示する。
    // return isNhGroupOperated ? '' : 'p-flight-detail01__item--other';
    // 3) 当該セグメント情報.operatingAirlineCode=自社2レター以外の場合、グレーを表示する。
    return operatingAirlineCode === this.appConstants.CARRIER.TWO_LETTER ? '' : 'p-flight-detail01__item--other';
  }

  // (1.1.19) フライト時間ライン - (1)
  isChangeClass(estimatedDateTime: string = '') {
    /** 1) 以下のいずれかに該当する場合、赤を表示する。
     * 1.1) 当該セグメント情報.departure.estimatedDateTimeが存在する場合、
     *      出発時刻から最新出発時刻(または最新出発時刻から出発時刻)までの領域に赤いラインを出力
     * 1.2) 当該セグメント情報.arrival.estimatedDateTimeが存在する場合、
     *      到着時刻から最新到着時刻(または最新到着時刻から到着時刻)までの領域に赤いラインを出力
     */
    return isStringEmpty(estimatedDateTime) ? '' : 'p-flight-detail01__item--changed';
  }

  // (1.1.49) 到着日付差 & (1.1.51) 最新到着日付差
  getDaysDifferenceLabel(num?: number): string {
    if (!num) return '';
    // 当該セグメント情報.(arrivalDaysDifferenceByFlight || estimatedArrivalDaysDifferenceByFlight)が存在する場合、以下の条件に従い表示する。
    switch (num) {
      // 1) 当該セグメント情報.(arrivalDaysDifferenceByFlight || estimatedArrivalDaysDifferenceByFlight)="-1"(前日)の場合、を赤字で表示する。
      case -1:
        return 'label.dayMinusOne';
      // 2) 当該セグメント情報.(arrivalDaysDifferenceByFlight || estimatedArrivalDaysDifferenceByFlight)="1"(翌日)の場合、を表示する。
      case 1:
        return 'label.dayPlusOne';
      // 3) 当該セグメント情報.(arrivalDaysDifferenceByFlight || estimatedArrivalDaysDifferenceByFlight)="2"(翌々日)の場合、を表示する。
      case 2:
        return 'label.dayPlusTwo';
      // 4) 当該セグメント情報.(arrivalDaysDifferenceByFlight || estimatedArrivalDaysDifferenceByFlight)≥""3""(出発日の3日後)の場合、出発日の3日後の旨の文言を表示する。
      default:
        return num >= 3 ? 'label.afterThreeDays' : '';
    }
  }

  buildTooltipIcon(img: string, alt: string = '', size: string = '24'): string {
    return `<img src="assets/images/${img}" width="${size}" height"${size}" alt="${alt}">`;
  }

  override destroy(): void {
    // Add comment to passed SonarLint
  }
}
